import apiClient from 'src/utils/apiClient';
import { Modification } from 'src/types/modification';

class ModificationService {
  /**
   * get regions
   */
  public async getModifications() {
    const res = await apiClient.get<Modification[]>('/modifications');
    return res.data;
  }

  /**
   * get regions
   */
  public async createOrupdateModifications(payload: Modification) {
    const res = await apiClient.post<Modification>('/modifications', payload);
    return res.data;
  }
}

export default new ModificationService();
